import Chart from "react-apexcharts";

const SKPChart = ({ rekapSKP }) => {
    if (!rekapSKP || rekapSKP.length === 0) return <p>Data belum tersedia.</p>;

    const SKPChartCategories = rekapSKP.map(item => item.nm_provinsi || item.uraian_propinsi);
    const SKPChartSeriesData = rekapSKP.map(item => item.jumlah_SKP || item.jumlah);

    const chartOptions = {
        chart: {
            type: 'bar',
            stacked: false,
            toolbar: { show: false },
            fontFamily: '"Inter", sans-serif'
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: '50%',
                dataLabels: {
                    position: 'bottom'
                },
                columnWidth: "45%",
                endingShape: "rounded",
                borderRadius: 5,
            }
        },
        xaxis: {
            categories: SKPChartCategories,
            labels: {
                style: {
                    colors: SKPChartCategories.map(() => "#0071CE"), // Hijau Tua
                    fontSize: "12px",
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: "#004D40", // Hijau Laut (untuk angka di sumbu X)
                    fontSize: "12px"
                }
            }
        },
        dataLabels: {
            enabled: false,
            style: {
                fontSize: '12px',
                colors: ['#fff']
            },
            dropShadow: {
                enabled: true,
                top: 1,
                left: 1,
                blur: 1,
                opacity: 0.45
            }
        },
        tooltip: {
            enabled: true
        },
        // GRADIENT BAR COLOR
        fill: {
            type: "gradient",
            gradient: {
                shade: "light",
                type: "horizontal",
                shadeIntensity: 0.5,
                gradientToColors: ["#0071CE"], // Akhir gradasi
                inverseColors: false,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100]
            },
            colors: ["#F7941E"] // Awal gradasi
        },
        grid: {
            show: true,
            xaxis: {
                lines: { show: true }
            },
            yaxis: {
                lines: { show: false }
            }
        }
    };

    const chartSeries = [{
        name: 'Jumlah SKP',
        data: SKPChartSeriesData
    }];

    return (
        <div>
            <Chart
                options={chartOptions}
                series={chartSeries}
                type="bar"
                height={rekapSKP.length * 30}
            />
        </div>
    );
};

export default SKPChart;